import config from '../../../../config/config';
import REST_API_NAMES from '../../../../config/restApiNames';

export const setTestimonials = (testimonials) => ({
  type: 'SET',
  payload: testimonials,
});

const _fetchTestimonials = () => {
  return fetch(config.REST_URL(REST_API_NAMES.v1Testimonials), {
    method: 'GET',
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(response);
    })
    .then((testimonials) => {
      return testimonials;
    })
    .catch((error) => {
      throw error;
    });
};

export const getTestimonials = () => {
  return (dispatch) => {
    return _fetchTestimonials()
      .then((testimonials) => {
        dispatch(setTestimonials(testimonials));
        return testimonials;
      })
      .catch((error) => {
        console.log('Error in getTestimonials(): ', error);
        throw error;
      });
  };
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/Testimonials/actions/index.js